import * as ActionTypes from './SinglePhotographerInvoiceActionTypes';
import { assign } from '../../../../shared/Assign';
import InitialState from './InitialState';

export default function singlePhotographerInvoiceReducer(
    state: any = InitialState,
    action: { type: string; result: any }
) {
    switch (action.type) {
        case ActionTypes.GET_PHOTOGRAPHER_INVOICE_LISTS_SUCCESS: {
            const newState = assign({}, state);
            newState.previewInvoices = action.result.previews;
            newState.pendingInvoices = action.result.pending;
            newState.invoiceHistory = action.result.history;
            return newState;
        }

        case ActionTypes.GET_PHOTOGRAPHER_INVOICE_SUCCESS: {
            const newState = assign({}, state);
            newState.html = action.result.html;
            newState.checksum = action.result.checksum;
            newState.instructions = action.result.instructions ? action.result.instructions : '';
            newState.rejectMessage = action.result.rejectMessage ? action.result.rejectMessage : '';
            return newState;
        }

        case ActionTypes.GET_PHOTOGRAPHER_INVOICES_FILTER_SUCCESS: {
            const newState = assign({}, state);
            newState.filter = action.result;
            return newState;
        }

        case ActionTypes.CLEAR_PHOTOGRAPHER_INVOICES_FILTER_PLACEHOLDER: {
            const newState = assign({}, state);
            if (newState.filter.availablePhotographers[0].id === 0) {
                newState.filter.availablePhotographers.shift();
            }
            return newState;
        }

        case ActionTypes.CLEAR_PHOTOGRAPHER_INVOICES_STATE: {
            return InitialState;
        }

        case ActionTypes.CLEAR_PHOTOGRAPHER_INVOICE_LISTS_STATE: {
            const newState = assign({}, state);
            newState.previewInvoices = [];
            newState.pendingInvoices = [];
            newState.invoiceHistory = [];
            return newState;
        }

        default:
            return state;
    }
}
